<template>
  <div class="dashboard-designer cdsp_dashboard" :style="dashboardStyle">
    <div class="action-panel-container" v-if="!previewFlag">
      <action-panel :showPublishBtn="showPublishBtn" :showShareBtn="showShareBtn" :mode="mode" :gridLayout="layoutObj" @on-export-img="handleExportImage"
        :previewFlag="previewFlag" v-model="isPc" @toggle-preview="handleTogglePreview" @on-submit="handleSubmit"
        @on-preview="onPreview" @on-share="onShare" @on-cancel="onCancel">
      </action-panel>
    </div>
    <div class="components-panel-container" v-show="!getPreviewFlag">
      <components-panel :chartConfigHandler="chartConfigHandler" :classifyList="classifyList" :mode="mode"
        :widgets="widgetsView" @drag="componentsPanelDrag" @dragend="componentsPanelDragend"
        @tab-change="handleTabChange" @click-add="handleClickAdd"></components-panel>
    </div>
    <div class="setting-panel-container" v-show="!getPreviewFlag && !isEmptyLayout">
      <setting-panel :getDwsData="getDwsData" @preview-detail="previewDetail" @on-update-single-chart="handleUpdateSingleChart"
        :custom_updateData="custom_updateData" :globalConfig="globalConfig" :selectItem="selectItem"
        :hideGauge="hideGauge" @updateDashboard="updateDashboard" @panel-toggle="handlePanelToggle"
        @updateFetchData="updateFetchData"></setting-panel>
    </div>
    <div class="canvas-panel-container" v-if="!previewDialogVisible">
      <mobile-preview v-if="!isPc">
        <canvas-panel :chartConfigHandler="chartConfigHandler" @sort-change="handleSortChange"
          @handle-table-command="handleTableCommand" @table-page-change="handleTablePageChange" ref="grid"
          :gridLayout.sync="mobileLayout" :previewFlag="previewFlag" @chartSelect="handleChartSelect"></canvas-panel>
      </mobile-preview>
      <canvas-panel :dashboardName="layoutObj.dashboardName" :chartDirection="chartDirection" :chartPreviewMode="chartPreviewMode" :previewMode="previewMode"
        :chartConfigHandler="chartConfigHandler" @sort-change="handleSortChange"
        @drill-item-click="handleDrillItemClick" :chartData="selectItem" @handle-table-command="handleTableCommand"
        @table-page-change="handleTablePageChange" v-else ref="grid" :gridLayout.sync="layoutObj.layout"
        :previewFlag="previewFlag" @chartSelect="handleChartSelect" @grid-resize="handleGridResize"></canvas-panel>
    </div>
    <el-dialog :visible.sync="previewDialogVisible" fullscreen append-to-body :close-on-click-modal="false"
      v-loading="exportingImage" element-loading-text="导出中，请稍候…" element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 1)" custom-class="jzliu_bi_engine_preview-full-dialog">
      <div style="height: 100%;">
        <div class="jzliu-preview-header">
          <div>
            <span>{{ layoutObj.dashboardName }}</span>
          </div>
          <div>
            <el-button size="small" @click="onBack">返回编辑</el-button>
            <el-button type="primary" size="small" @click="handleSubmit('save')">保存</el-button>
          </div>
        </div>
        <div ref="previewContainer" style="height: calc(100% - 50px);overflow-y: auto;">
          <preview ref="previewComponent" @sort-change="handleSortChange" @drill-item-click="handleDrillItemClick"
            @handle-table-command="handleTableCommand" v-if="previewDialogVisible"
            :layoutObj="{ layout: layoutObj.layout, dashboardName: layoutObj.dashboardName }" :widgets="widgetsView" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 移除 Vuex 依赖，使用内部状态管理
import './assets/style/dashboard.less'
import actionPanel from './components/actionPanel.vue'
import canvasPanel from './components/canvasPanel.vue'
import componentsPanel from './components/componentsPanel.vue'
import settingPanel from './components/settingPanel.vue'
import mobilePreview from './components/mobilePreview.vue'
import preview from './components/preview/index.vue'
// import { getDashboardConfigDetail } from 'cdsp_sharedKernel/service'
import { updatePanelWidget, updateChartDataHelper } from './utils/index'
import { DragPos, defaultDrillField } from './utils/panelConf'
import { initWidget } from './utils/utils'
import { exportImage } from './utils/utils'

const dragPos = DragPos()
let mouseXY = { x: null, y: null }
let autoScrollTimer = null
export default {
  name: 'biDashboard',
  props: {
    chartDirection: {
      type: String,
      default: 'rtl'
    },
    chartPreviewMode: {
      type: String,
      default: 'dialog'
    },
    previewMode: {
      type: String,
      default: 'drawer'
    },
    previewFlag: {
      type: Boolean,
      default: false,
    },
    showPublishBtn: {
      type: Boolean,
      default: true,
    },
    showShareBtn: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: '',
    },
    custom_updateData: {
      type: Function | Object,
      default: null,
    },
    getDwsData: {
      type: Function,
      default: () => Promise.resolve([])
    },
    hideGauge: {
      type: Boolean,
      default: false,
    },
    layoutObj: {
      type: Object,
      default: () => {
        return {
          layout: [],
          dashboardName: '未命名',
          isExpired: false,
        }
      },
    },
    // 外部传入的 widgets 数据
    widgets: {
      type: Array,
      default: () => []
    },
    widgetsView: {
      type: Array,
      default: () => []
    },
    classifyList: {
      type: Array,
      default: () => []
    },
    chartConfigHandler: {
      type: Function,
      default: (conf) => conf,
    },
  },
  components: { actionPanel, canvasPanel, componentsPanel, settingPanel, mobilePreview, preview },
  data() {
    return {
      isPrewview: true,
      globalConfig: {
        dashboardDesignerWidth: 420,
      },
      isPc: true,
      layoutObjClone: {
        layout: [],
        dashboardName: '未命名',
      },
      selectItem: {},
      previewDialogVisible: false,
      exportingImage: false,
    }
  },
  computed: {
    isEmptyLayout() {
      return !this.layoutObj.layout?.length
    },
    // 内部状态计算属性
    getDashboardDesignerWidth() {
      return this.globalConfig.dashboardDesignerWidth
    },
    getPreviewFlag() {
      return this.previewFlag
    },
    dashboardStyle() {
      let initAreas = this.isEmptyLayout ? '"action action" "components components" "canvas canvas" "components-mode components-mode"' : '"action action" "components setting" "canvas setting" "components-mode setting"'
      let previewAreas = '"canvas"'
      return {
        gridTemplateColumns: !this.getPreviewFlag ? `1fr ${this.globalConfig.dashboardDesignerWidth}px` : '1fr',
        gridTemplateAreas: this.getPreviewFlag ? previewAreas : initAreas,
        gridTemplateRows: !this.getPreviewFlag ? '50px 48px 1fr' : '48px 1fr',
      }
    },
    mobileLayout: {
      get() {
        return JSON.parse(JSON.stringify(this.layoutObj.layout))
      },
      set() {
        // 占位setter 避免报错
      },
    },
  },
  created() {
    // 修复历史数据中可能存在的重复 i 值
    this.fixDuplicateIds()
  },
  mounted() {
    document.addEventListener('dragover', this.dragover, false)
    document.addEventListener('keydown', this.onKeydown)
  },
  watch: {
    widgets: {
      handler(newWidgets) {
        if (newWidgets && newWidgets.length > 0) {
          newWidgets.forEach((item,index) => {
            if(!item.virtualId) {
              item.virtualId = `virtualId_${index}`
            }
          })
        }
      },
      deep: true,
      immediate: true
    },
    widgetsView: {
      handler(newWidgetsView) {
        if (newWidgetsView && newWidgetsView.length > 0) {
          newWidgetsView.forEach((item,index) => {
            if(!item.virtualId) {
              item.virtualId = `virtualId_${index}`
            }
          })
        }
      },
      deep: true,
      immediate: true
    },
    // 监听外部传入的 layoutObj，如果数据变化则修复重复 ID
    'layoutObj.layout': {
      handler(newLayout) {
        if (newLayout && newLayout.length > 0) {
          this.$nextTick(() => {
            this.fixDuplicateIds()
          })
        }
      },
      deep: true,
      immediate: false
    }
  },
  methods: {
    getNewId() {
      return `id_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
    },
    // 修复重复的 i 值
    fixDuplicateIds() {
      if (!this.layoutObj.layout || this.layoutObj.layout.length === 0) {
        return
      }

      const seenIds = new Set()
      const duplicateIndices = []

      // 找出所有重复的 i 值
      this.layoutObj.layout.forEach((item, index) => {
        if (!item.i || seenIds.has(item.i)) {
          duplicateIndices.push(index)
        } else {
          seenIds.add(item.i)
        }
      })

      // 如果有重复，重新生成唯一 ID
      if (duplicateIndices.length > 0) {
        duplicateIndices.forEach(index => {
          const item = this.layoutObj.layout[index]
          const oldId = item.i
          // 生成新的唯一 ID
          let newId = item._id || this.getNewId()

          // 确保新 ID 也不重复
          while (seenIds.has(newId)) {
            newId = this.getNewId()
          }

          // item.i = newId
          item._id = newId
          seenIds.add(newId)
        })
      }
    },
    previewDetail(selectItem) {
      this.$refs.grid.previewDetail(selectItem)
    },
    onCancel() {
      this.$emit('on-cancel')
    },
    onShare() {
      this.$emit('on-share')
    },
    handleTableCommand(command, item = null) {
      this.$emit('handle-table-command', command, item)
    },
    handleTablePageChange(current, pageSize) {
      this.$emit('table-page-change', current, pageSize)
    },
    handleSubmit(type) {
      this.$emit('on-submit', type)
    },
    onPreview() {
      this.layoutObjClone = JSON.parse(JSON.stringify(this.layoutObj))
      // 打开对话框预览
      this.previewDialogVisible = true
    },
    handleTogglePreview(newPreviewFlag) {
      this.previewFlag = newPreviewFlag
    },
    // 处理 tab 切换事件
    handleTabChange(tabInfo) {
      this.$emit('tab-change', tabInfo)
    },
    // 处理面板切换事件
    handlePanelToggle(widthChange) {
      // 这里可以根据需要处理面板宽度变化
      // 由于移除了 Vuex，这里暂时不处理具体的宽度调整
      this.globalConfig.dashboardDesignerWidth = widthChange
    },
    updateFetchData(selectItem) {
      this.$emit('updateFetchData', selectItem)
    },
    // 点击更新按钮事件
    handleUpdateSingleChart() {
      this.$refs.grid.updateSingleChart()
    },
    handleDrillItemClick(data, item = null) {
      this.$emit('drill-item-click', data, item)
    },
    handleSortChange(column) {
      this.$emit('sort-change', column)
    },
    async getDetail() {
      try {
        const {
          data: { dashboardName, dashboardUnitInfos },
        } = await getDashboardConfigDetail({ wid: this.wid })
        this.layoutObj = {
          dashboardName,
          layout: dashboardUnitInfos.map((v) => {
            const unit = JSON.parse(v.unitDefine)
            return {
              ...unit,
              wid: v.wid,
              describe: v.unitName || '未命名图表',
            }
          }),
        }
      } catch ({ errmsg }) {
        this.$message.error(errmsg)
      }
    },
    getResponsiveGrid(type) {
      // const el = document.querySelector('.gridlayout')
      // const {name} = getCanvasWidth(el)
      // const whole = responsiveMap[name]
      const whole = 12
      return type === 'whole' ? whole : whole / 2
    },
    dragover(e) {
      mouseXY.x = e.clientX
      mouseXY.y = e.clientY
    },
    onKeydown(e) {
      // 这里需要对target元素校验下 如果是input等元素可能需要删除文字
      const targetTagName = document.activeElement?.tagName?.toLowerCase()
      // 绑定chart删除事件
      let selectItemIndex = this.layoutObj.layout.findIndex((v) => v._select)
      if (!selectItemIndex < 0 || ['input', 'textarea'].includes(targetTagName)) return
      if (['Backspace', 'Delete'].includes(e.key)) {
        this.layoutObj.layout.splice(selectItemIndex, 1)
      }
    },
    updateDashboard(chartData) {
      if (!chartData || typeof chartData !== 'object') return

      // 优先保留已有的 name，防止外部数据遗漏
      const preservedName = chartData.name ?? this.selectItem?.name ?? ''

      // 若 selectItem 已经存在，则保持同一个响应式引用
      if (this.selectItem && Object.keys(this.selectItem).length) {
        // 删除在 chartData 中不存在的旧属性
        Object.keys(this.selectItem).forEach(key => {
          if (!Object.prototype.hasOwnProperty.call(chartData, key)) {
            this.$delete(this.selectItem, key)
          }
        })
        // 同步 chartData 中的最新属性
        Object.keys(chartData).forEach(key => {
          this.$set(this.selectItem, key, chartData[key])
          // this.$set(this.selectItem, '_id', this.getNewId())
        })
      } else {
        // 第一次赋值直接引用，保持响应式
        this.selectItem = chartData
      }

      this.$set(this.selectItem, 'name', preservedName)

      // 同时更新 layoutObj.layout 中对应的图表
      if (chartData._id) {
        const chartIndex = this.layoutObj.layout.findIndex(item => item._id === chartData._id)
        if (chartIndex !== -1) {
          const tempItem = this.layoutObj.layout[chartIndex]
          Object.assign(tempItem, this.selectItem)
        }
      }

      updatePanelWidget(this.selectItem)
      // 再次确保 name 没被覆盖
      this.$set(this.selectItem, 'name', preservedName)
    },
    handleChartSelect(chartData) {
      // 当图表被选中时，完全替换 selectItem
      this.selectItem = chartData
      initWidget(this.selectItem);
    },
    handleGridResize(item) {
      // 处理网格大小变化事件
      // 可以在这里添加全局的 resize 处理逻辑
    },
    updateDropPlaceholder(panel, layoutGrid) {
      // 更新占位符位置（在滚动时调用）
      if (!layoutGrid) {
        layoutGrid = this.$refs.grid?.$refs.gridlayout
      }
      if (!layoutGrid) return

      const index = this.layoutObj.layout.findIndex((item) => item.i === 'drop')
      if (index === -1) return

      // 获取容器和滚动信息
      const canvasContainer = document.querySelector('.canvas-panel-container .root-container')
      const scrollTop = canvasContainer ? canvasContainer.scrollTop : 0

      // 重新获取 grid 的位置（滚动后会改变）
      const parentRect = layoutGrid.$el.getBoundingClientRect()

      // 更宽松的判断：只要在水平范围内就可以
      const mouseInGrid = mouseXY.x > parentRect.left && mouseXY.x < parentRect.right

      if (!mouseInGrid) return

      const el = layoutGrid.$children[index]
      if (!el) return

      // 使用相同的简化策略
      let relativeY = mouseXY.y - parentRect.top
      let relativeX = mouseXY.x - parentRect.left

      // 重新计算相对位置
      el.dragging = {
        top: relativeY,
        left: relativeX
      }
      const new_pos = el.calcXY(relativeY, relativeX)

      // 更新占位符位置
      layoutGrid.dragEvent(
        'dragstart',
        'drop',
        new_pos.x,
        new_pos.y,
        panel.defaultRows,
        this.getResponsiveGrid(panel.defaultCols)
      )

      // 更新 dragPos - 使用 panel._id 作为唯一标识
      dragPos.i = panel._id || this.getNewId()
      dragPos.x = this.layoutObj.layout[index].x
      dragPos.y = this.layoutObj.layout[index].y + 1
    },
    getPanelOpt(panel) {
      const findId = this.widgetsView.findIndex(item => item.virtualId === panel.virtualId)
      const result = JSON.parse(JSON.stringify(this.widgets[findId]))
      result._id = this.getNewId()
      result.i = panel.i
      return result
    },
    componentsPanelDrag(panelOpt) {
      const panel = this.getPanelOpt(panelOpt)
      // 确保 panel 有唯一 ID（应该在 componentsPanel 的 drag 方法中已经生成）
      if (!panel._id) {
        panel._id = this.getNewId()
      }
      // 使用 panel._id 作为唯一标识
      dragPos.i = panel._id
      const layoutGrid = this.$refs.grid.$refs.gridlayout
      const canvasContainer = document.querySelector('.canvas-panel-container .root-container')

      // 使用容器的边界来判断，而不是 grid 的边界，这样更稳定
      let mouseInContainer = false
      if (canvasContainer) {
        const containerRect = canvasContainer.getBoundingClientRect()
        // 考虑滚动偏移，调整边界检测
        const scrollTop = canvasContainer.scrollTop
        const scrollLeft = canvasContainer.scrollLeft
        mouseInContainer = mouseXY.x > containerRect.left &&
          mouseXY.x < containerRect.right &&
          mouseXY.y > containerRect.top &&
          mouseXY.y < containerRect.bottom
      }

      // 获取 grid 的边界（用于后续计算）
      let parentRect = layoutGrid.$el.getBoundingClientRect()

      // 检查鼠标是否在 grid 的水平范围内，垂直方向上更宽松（允许在容器内就算）
      let mouseInGrid = mouseInContainer &&
        mouseXY.x > parentRect.left &&
        mouseXY.x < parentRect.right

      // 自动滚动逻辑
      if (canvasContainer && mouseInContainer) {
        const scrollThreshold = 80 // 触发滚动的边缘阈值（像素）
        const scrollSpeed = 10 // 滚动速度

        // 清除之前的定时器
        if (autoScrollTimer) {
          clearInterval(autoScrollTimer)
          autoScrollTimer = null
        }

        const containerRect = canvasContainer.getBoundingClientRect()
        const distanceFromBottom = containerRect.bottom - mouseXY.y
        const distanceFromTop = mouseXY.y - containerRect.top

        // 检测是否需要滚动
        if (distanceFromBottom < scrollThreshold || distanceFromTop < scrollThreshold) {
          autoScrollTimer = setInterval(() => {
            // 重新获取容器位置和鼠标位置
            const currentContainerRect = canvasContainer.getBoundingClientRect()
            const currentDistanceFromBottom = currentContainerRect.bottom - mouseXY.y
            const currentDistanceFromTop = mouseXY.y - currentContainerRect.top

            if (currentDistanceFromBottom < scrollThreshold && currentDistanceFromBottom > 0) {
              // 向下滚动
              canvasContainer.scrollTop += scrollSpeed
              // 滚动后立即更新占位符位置
              this.updateDropPlaceholder(panel, layoutGrid)
            } else if (currentDistanceFromTop < scrollThreshold && currentDistanceFromTop > 0) {
              // 向上滚动
              canvasContainer.scrollTop -= scrollSpeed
              // 滚动后立即更新占位符位置
              this.updateDropPlaceholder(panel, layoutGrid)
            } else {
              // 鼠标已经离开边缘区域，停止滚动
              if (autoScrollTimer) {
                clearInterval(autoScrollTimer)
                autoScrollTimer = null
              }
            }
          }, 16) // 约60fps
        }
      }

      if (mouseInGrid === true && this.layoutObj.layout.findIndex((item) => item.i === 'drop') === -1) {
        this.layoutObj.layout.push({
          x: (this.layoutObj.layout.length * 2) % (this.colNum || 12),
          y: this.layoutObj.layout.length + (this.colNum || 12),
          w: this.getResponsiveGrid(panel.defaultCols),
          h: panel.defaultRows,
          i: 'drop',
        })
      }
      let index = this.layoutObj.layout.findIndex((item) => item.i === 'drop')
      if (index !== -1) {
        try {
          layoutGrid.$children[this.layoutObj.layout.length].$refs.item.style.display = 'none'
        } catch (e) { console.log('e:', e) }
        let el = layoutGrid.$children[index]
        // 重新获取最新的 parentRect，确保位置计算准确
        parentRect = layoutGrid.$el.getBoundingClientRect()

        // 获取容器滚动信息
        const scrollTop = canvasContainer ? canvasContainer.scrollTop : 0


        // 完全重写位置计算逻辑 - 使用最简单的方法
        // 直接使用鼠标相对于grid的坐标，不做任何复杂计算
        let relativeY = mouseXY.y - parentRect.top
        let relativeX = mouseXY.x - parentRect.left

        // 直接使用计算出的坐标，不做任何调整
        el.dragging = { top: relativeY, left: relativeX }
        let new_pos = el.calcXY(relativeY, relativeX)

        if (mouseInGrid === true) {
          layoutGrid.dragEvent(
            'dragstart',
            'drop',
            new_pos.x,
            new_pos.y,
            panel.defaultRows,
            this.getResponsiveGrid(panel.defaultCols)
          )
          // 使用 panel._id 作为唯一标识，如果没有则生成一个
          dragPos.i = panel._id || this.getNewId()
          dragPos.x = this.layoutObj.layout[index].x
          dragPos.y = this.layoutObj.layout[index].y + 1
        }
        if (mouseInGrid === false) {
          layoutGrid.dragEvent('dragend', 'drop', new_pos.x, new_pos.y, 1, 1)
          this.layoutObj.layout = this.layoutObj.layout.filter((obj) => obj.i !== 'drop')
        }
      }
    },
    componentsPanelDragend(panelOpt) {
      const panel = this.getPanelOpt(panelOpt)
      // 清除自动滚动定时器
      if (autoScrollTimer) {
        clearInterval(autoScrollTimer)
        autoScrollTimer = null
      }

      const layoutGrid = this.$refs.grid.$refs.gridlayout
      const canvasContainer = document.querySelector('.canvas-panel-container .root-container')

      // 使用与 componentsPanelDrag 相同的宽松判断逻辑
      let mouseInContainer = false
      if (canvasContainer) {
        const containerRect = canvasContainer.getBoundingClientRect()
        // 考虑滚动偏移，调整边界检测
        const scrollTop = canvasContainer.scrollTop
        const scrollLeft = canvasContainer.scrollLeft
        mouseInContainer = mouseXY.x > containerRect.left &&
          mouseXY.x < containerRect.right &&
          mouseXY.y > containerRect.top &&
          mouseXY.y < containerRect.bottom
      }

      let parentRect = layoutGrid.$el.getBoundingClientRect()
      // 检查鼠标是否在 grid 的水平范围内，垂直方向上更宽松（允许在容器内就算）
      let mouseInGrid = mouseInContainer &&
        mouseXY.x > parentRect.left &&
        mouseXY.x < parentRect.right

      if (mouseInGrid === true) {
        layoutGrid.dragEvent('dragend', 'drop', dragPos.x, dragPos.y, 1, 1)
        this.layoutObj.layout = this.layoutObj.layout.filter((obj) => obj.i !== 'drop')
        const cur = {
          ...panel,
          x: dragPos.x,
          y: dragPos.y,
          w: this.getResponsiveGrid(panel.defaultCols),
          h: panel.defaultRows,
          i: dragPos.i,         // Vue Grid Layout 使用的 key
          _id: dragPos.i,       // 确保 _id 和 i 保持一致
          originCol: this.getResponsiveGrid('whole'),
          originWidth: this.getResponsiveGrid(panel.defaultCols),
        }
        // 确保 fields 中每个字段都有 chooseFields 属性
        if (cur.fields && cur.fields.length > 0) {
          cur.fields.forEach(field => {
            if (!field.chooseFields) {
              this.$set(field, 'chooseFields', [])
            }
          })
        }

        updatePanelWidget(cur)
        this.handleChartSelect(cur)
        this.layoutObj.layout.push(cur)

        // 立即更新 selectItem，让字段立刻渲染
        Object.assign(this.selectItem, cur)
        layoutGrid.dragEvent('dragend', dragPos.i, dragPos.x, dragPos.y, 1, 1)
        try {
          layoutGrid.$children[this.layoutObj.layout.length].$refs.item.style.display = 'block'
        } catch (e) { console.log('e:', e) }
      }
    },
    onBack() {
      this.previewDialogVisible = false
    },
    async handleExportImage() {
      this.exportingImage = true
      this.onPreview()
      await this.$nextTick()
      this.$refs.previewComponent.handleExportImage(this)
    },
    handleClickAdd(panelOpt) {
      const panel = this.getPanelOpt(panelOpt)
      // 计算新图表应该放置的位置（放在最后一个）
      const colNum = this.colNum || 12
      let maxY = 0
      let maxYItems = []

      // 找到最底部的图表
      if (this.layoutObj.layout.length > 0) {
        this.layoutObj.layout.forEach(item => {
          const itemBottom = item.y + item.h
          if (itemBottom > maxY) {
            maxY = itemBottom
            maxYItems = [item]
          } else if (itemBottom === maxY) {
            maxYItems.push(item)
          }
        })
      }

      // 计算新图表的位置
      let newX = 0
      let newY = maxY

      // 如果最底部有图表，尝试在同一行找空位
      if (maxYItems.length > 0) {
        // 计算最后一行已占用的宽度
        const occupiedWidth = maxYItems.reduce((sum, item) => sum + item.w, 0)
        const availableWidth = colNum - occupiedWidth
        const newWidth = this.getResponsiveGrid(panel.defaultCols)

        // 如果当前行还有足够空间，就放在同一行
        if (availableWidth >= newWidth) {
          newX = occupiedWidth
          newY = maxYItems[0].y
        } else {
          // 否则另起一行
          newX = 0
          newY = maxY
        }
      }

      // 确保 panel 有唯一 ID
      if (!panel._id) {
        panel._id = this.getNewId()
      }

      // 创建新图表对象
      const newChart = {
        ...panel,
        x: newX,
        y: newY,
        w: this.getResponsiveGrid(panel.defaultCols),
        h: panel.defaultRows,
        i: panel._id,         // Vue Grid Layout 使用的 key
        _id: panel._id,       // 确保 _id 和 i 保持一致
        originCol: this.getResponsiveGrid('whole'),
        originWidth: this.getResponsiveGrid(panel.defaultCols),
      }

      // 确保 fields 中每个字段都有 chooseFields 属性
      if (newChart.fields && newChart.fields.length > 0) {
        newChart.fields.forEach(field => {
          if (!field.chooseFields) {
            this.$set(field, 'chooseFields', [])
          }
        })
      }

      // 添加到布局
      updatePanelWidget(newChart)
      this.handleChartSelect(newChart)
      this.layoutObj.layout.push(newChart)

      // 立即更新 selectItem
      Object.assign(this.selectItem, newChart)

      // 滚动到新添加的图表位置
      this.$nextTick(() => {
        const canvasContainer = document.querySelector('.canvas-panel-container .root-container')
        if (canvasContainer) {
          // 平滑滚动到底部
          canvasContainer.scrollTo({
            top: canvasContainer.scrollHeight,
            behavior: 'smooth'
          })
        }
      })
    },
  },
  beforeDestroy() {
    document.removeEventListener('dragover', this.dragover)
    document.removeEventListener('keydown', this.onKeydown)
    // 清除自动滚动定时器
    if (autoScrollTimer) {
      clearInterval(autoScrollTimer)
      autoScrollTimer = null
    }
  },
}
</script>

<style scoped lang="less">
.dashboard-designer {
  display: grid;
  display: -ms-grid;
  height: 100%;
  width: 100%;
  overflow: auto;
  //grid-template-areas:
  //      "action action"
  //      "components setting"
  //      "canvas setting"
  //      "components-mode setting";
  grid-template-rows: 50px 48px 1fr;

  .action-panel-container {
    grid-area: action;
    display: flex;
    position: relative;
    z-index: 310;
  }

  .components-panel-container {
    grid-area: components;
    display: flex;
    align-items: center;
    position: relative;
  }

  .setting-panel-container {
    grid-area: setting;
    display: flex;
    background: var(--bi-jz-bg-color);
  }

  .canvas-panel-container {
    grid-area: canvas;
    position: relative;
    overflow: auto;
  }
}
</style>
<style lang="less">
.jzliu_bi_engine_preview-full-dialog {
  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
    max-height: inherit;
    height: 100vh;
  }
}

.bi_dashboard_text_overflow {
  display: block !important;          /* 关键 */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.jzliu-preview-header{
  height: 50px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid #e6e6e6;
}
</style>
